import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import banner from "../../assets/banner.jpg";

const settings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed:4000,
  easing: 'ease-in-out',
  pauseOnHover: true,
};

const Banner = () => {
  return (
    <div className="banner container">
      <div className="banner-slider">
        <Slider {...settings}>
          <img src={banner} alt="banner" className="img-slider" />
          <img src={banner} alt="banner" className="img-slider" />
          <img src={banner} alt="banner" className="img-slider" />
        </Slider>
      </div>
    </div>
  );
};

export default Banner;
